var _defs, _circle, _path, _path2, _path3, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolutionsEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 66.14 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6e14;}.cls-2{fill:#544994;}.cls-3{fill:#281978;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.26,
    cy: 37.74,
    r: 3.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.78,23.18h16.58c3.17,0,5.78,2.4,6.12,5.48l13.53-5.64-27.93-11.33L5.14,23.02l13.53,5.64c.34-3.08,2.95-5.48,6.12-5.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.52,29.34c0-.23-.01-.45-.04-.67l-14.41,6.01-14.41-6.01c-.02.22-.04.45-.04.67v15.07h28.89v-15.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m47.48,28.67c-.34-3.08-2.95-5.48-6.12-5.48h-16.58c-3.17,0-5.78,2.4-6.12,5.48l14.41,6.01,14.41-6.01Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.85 26.05 56.66 24.88 56.66 36.75 53.85 36.75 53.85 26.05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsEducation);
export default __webpack_public_path__ + "static/media/Solutions_Education.d34787f0758348b950c46393610a26c7.svg";
export { ForwardRef as ReactComponent };